import { getIsMobile } from "../../helpers/getIsMobile";
import { html } from "../../helpers/stringHTML";

export const TIPS_CONFIG = {
    main: [
        {
            text: html`
                <p>Измените тип отображения</p>
                <p class="tip__text-indent">2D - вид сверху</p>
                <p class="tip__text-indent">3D - Объемный вид</p>
                <br />
                <p>Добавьте размеры в помещение</p>
            `,
            target: ".view2d3d",
            orientation: "right",
        },
        {
            text: html`
                <p>
                    Сохраните, загрузите или поделитесь<br />
                    созданным проектом
                </p>
            `,
            target: "#project-actions",
            orientation: {
                desktop: "right",
                mobile: "top",
            },
        },
        {
            text: html`
                <p>Это Ваше помещение.</p>
                <p>Добавьте в него мебель из меню справа.</p>
                <p>Расставьте в нужном месте.</p>
            `,
            target: "#ann_floor",
            orientation: "right",
            display: "desktop",
        },
        {
            text: html`
                <p>Это Ваше помещение.</p>
                <p>Добавьте в него мебель из меню «Параметры».</p>
                <p>Расставьте в нужном месте.</p>
            `,
            target: "#ann_floor",
            orientation: "right",
            display: "mobile",
        },
        {
            text: html`
                <p>Измените размеры помещения.</p>
                <p>Покрасьте стены и пол в нужный цвет.</p>
                <p>Добавьте стены и перегородки.</p>
            `,
            target: ".room_params_btn",
            orientation: "left",
            display: "desktop",
        },
        {
            text: html` <p>Выберите раздел с товарами</p> `,
            target: ".industrial_furniture_btn",
            orientation: "left",
            display: "desktop",
        },
        {
            text: html` <p>Оформить заказ или скачать спецификацию</p> `,
            target: ".side_footer__btns_wrap",
            orientation: {
                desktop: "left",
                mobile: "top",
            },
            display: "desktop",
        },
        {
            text: html` <p>Измените параметры помещения и выберите товар для размещения</p> `,
            target: ".open-params-mobile",
            orientation: "bottom",
            display: "mobile",
        },
    ],
    product: [
        {
            text: html`
                <p>
                    Сохраните, загрузите или поделитесь<br />
                    созданным проектом
                </p>
            `,
            target: "#project-actions",
            orientation: {
                desktop: "right",
                mobile: "top",
            },
        },
        {
            text: html`
                <p>
                    Выберите размер,<br />
                    добавьте комплектующие.
                </p>
                <br />
                <p>Результат и цена изменятся сразу</p>
            `,
            target: ".tip-select-size",
            orientation: "left",
            display: "desktop",
        },
        {
            text: html` <p>Вернуться к выбору других товаров</p> `,
            target: ".back_btn",
            orientation: "left",
            display: "desktop",
        },
        {
            text: html` <p>Оформить заказ или скачать спецификацию</p> `,
            target: ".side_footer__btns_wrap",
            orientation: "left",
            display: "desktop",
        },
        {
            text: html`
                <p>Это выбранная конфигурация.</p>
                <br />

                <p>Добавьте опции из меню справа.</p>
                <br />

                <p>Некоторые элементы можно передвигать</p>
                <p>(при наведении появится рука)</p>
                <br />

                <p>Можно вращать и приближать кнопками мыши</p>
            `,
            target: ".ann_target_table",
            orientation: {
                desktop: "right",
                mobile: "bottom",
            },
            display: "desktop",
        },
        {
            text: html`
                <p>Это выбранная конфигурация.</p>
                <br />

                <p>Добавьте опции из меню «Параметры».</p>
                <br />

                <p>Некоторые элементы можно передвигать</p>
                <br />

                <p>Можно вращать и приближать</p>
            `,
            target: ".ann_target_table",
            orientation: {
                desktop: "right",
                mobile: "bottom",
            },
            display: "mobile",
        },
        {
            text: html`
                <p>Укажите нужные параметры для товара:</p>
                <p>Цвет, размеры, дополнительные элементы и т.д.</p>
            `,
            target: ".open-params-mobile",
            orientation: "bottom",
            display: "mobile",
        },
    ],
};

export const resolveResponsive = (value) => {
    if (typeof value === "object" && value !== null && ("mobile" in value || "desktop" in value)) {
        return getIsMobile() ? value.mobile : value.desktop;
    }
    return value;
};
